import { useMemo } from 'react'
import { useSelector } from 'react-redux'

import { useAllEpisodesForSelectedClient } from './useAllEpisodesForSelectedClient'
import { getSelectedClientId } from '../../../../data/lyraTherapy/clientSelectors'
import { pickEpisode } from '../pickEpisode'

// useCurrentEpisodeForClient's rule over the patient-scoped endpoint instead of the provider-scoped
// one, which returns nothing for a provider who isn't the client's primary.
export const useActiveEpisodeForSelectedClient = () => {
  // `data` holds the last result for any arg, so mid client-switch it is the previous client's.
  const { currentData: episodes, isLoading: loadingEpisodes } = useAllEpisodesForSelectedClient()
  const selectedClientId = useSelector(getSelectedClientId)
  const activeEpisode = useMemo(() => pickEpisode(episodes, selectedClientId), [selectedClientId, episodes])
  return {
    activeEpisode,
    loadingEpisodes,
  }
}
